module.exports = __webpack_public_path__ + "img/campionario.6c5faa69.svg";